export function getExtensionFromBase64(base64: string): string {
  const [base64Header] = base64.split(',');

  // Matches example: ["data:image/jpeg;base64", "data:image/", "jpeg", ";base64"]
  const base64HeaderMatches = /^(data:image\/)([a-zA-Z]+)(;base64)/.exec(
    base64Header
  );

  return base64HeaderMatches ? base64HeaderMatches[2] : '';
}
